var REMOVE_DIALOG_ACTION;
(function (REMOVE_DIALOG_ACTION) {
  REMOVE_DIALOG_ACTION["STOP_LOADING"] = "StopLoading";
  REMOVE_DIALOG_ACTION["CANCEL"] = "Cancel";
})(REMOVE_DIALOG_ACTION || (REMOVE_DIALOG_ACTION = {}));

export { REMOVE_DIALOG_ACTION };
